export const VERTICAL_LINK = "VERTICAL_LINK";
export const STRAIGHT_LINE = "STRAIGHT_LINE";
export const ARC_LINE = "ARC_LINE";